'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/social/Apple.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var AppleIcon = ({ className = "" }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    className,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx("path", { d: "M17.05 12.536c-.027-2.708 2.214-4.006 2.315-4.07-1.26-1.844-3.222-2.097-3.92-2.125-1.668-.169-3.255 .98-4.102 .98-.843 0-2.15-.955-3.535-.93-1.82 .027-3.495 1.057-4.43 2.686-1.888 3.276-.483 8.124 1.357 10.78 .898 1.3 1.968 2.758 3.372 2.706 1.353-.054 1.864-.875 3.5-.875 1.636 0 2.096 .875 3.526 .848 1.456-.027 2.379-1.324 3.27-2.628 1.03-1.508 1.453-2.97 1.476-3.045-.032-.014-2.83-1.086-2.857-4.31z" }),
      /* @__PURE__ */ jsx("path", { d: "M14.616 4.62c.746-.904 1.25-2.163 1.112-3.415-1.075 .043-2.378 .716-3.15 1.62-.69 .8-1.296 2.08-1.134 3.307 1.2 .093 2.426-.61 3.172-1.512z" })
    ]
  }
);

// src/social/Chat.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ChatIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4C7.58172 4 4 7.58172 4 12C4 13.2058 4.26609 14.3466 4.7418 15.3694C4.92997 15.774 4.99885 16.2522 4.88275 16.728L4.1041 19.919L7.43287 19.1674C7.88799 19.0646 8.34252 19.1299 8.73063 19.3039C9.7275 19.7509 10.8333 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.5458 22 9.16153 21.689 7.91234 21.1288C7.88806 21.1179 7.87434 21.1184 7.87217 21.1185L4.54464 21.8699C3.09629 22.197 1.80913 20.8874 2.16111 19.4449L2.93944 16.2552C2.93961 16.2529 2.94023 16.2384 2.92835 16.2129C2.33228 14.9313 2 13.5031 2 12Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Facebook.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var Facebook = (props) => {
  return /* @__PURE__ */ jsx3(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx3(
        "path",
        {
          d: "M9.58404 21.706V15.0561H7.52015V12H9.58404V10.6833C9.58404 7.27944 11.124 5.70333 14.464 5.70333C15.0963 5.70333 16.1879 5.82722 16.6363 5.95111V8.71944C16.4001 8.69556 15.9879 8.68333 15.4801 8.68333C13.8401 8.68333 13.2079 9.30333 13.2079 10.9194V12H16.4763L15.9163 15.0556H13.2124V21.9277C18.1637 21.3279 22 17.112 22 12C22 6.47722 17.5228 2 12 2C6.47722 2 2 6.47722 2 12C2 16.6899 5.22813 20.6253 9.58404 21.706Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Google.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var GoogleIcon = ({ className = "" }) => /* @__PURE__ */ jsxs2("svg", { className, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx4(
    "path",
    {
      d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z",
      fill: "#4285F4"
    }
  ),
  /* @__PURE__ */ jsx4(
    "path",
    {
      d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z",
      fill: "#34A853"
    }
  ),
  /* @__PURE__ */ jsx4(
    "path",
    {
      d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z",
      fill: "#FBBC05"
    }
  ),
  /* @__PURE__ */ jsx4(
    "path",
    {
      d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z",
      fill: "#EA4335"
    }
  )
] });

// src/social/LinkedIn.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var LinkedIn = (props) => {
  return /* @__PURE__ */ jsx5(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx5(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.625 21.8037C18.5547 21.8037 19.3496 21.4736 20.0098 20.8135C20.6699 20.1533 21 19.3584 21 18.4287V7.17871C21 6.24902 20.6699 5.4541 20.0098 4.79395C19.3496 4.13379 18.5547 3.80371 17.625 3.80371H6.375C5.44531 3.80371 4.65039 4.13379 3.99023 4.79395C3.33008 5.4541 3 6.24902 3 7.17871V18.4287C3 19.3584 3.33008 20.1533 3.99023 20.8135C4.65039 21.4736 5.44531 21.8037 6.375 21.8037H17.625ZM7.12424 9.63968H7.11253C6.66721 9.63968 6.30588 9.50491 6.02854 9.23538C5.7512 8.96585 5.61253 8.63186 5.61253 8.23342C5.61253 7.82717 5.7551 7.49124 6.04026 7.22561C6.32542 6.95999 6.69456 6.82717 7.14768 6.82717C7.60081 6.82717 7.96409 6.95999 8.23753 7.22561C8.51096 7.49124 8.65159 7.82717 8.6594 8.23342C8.6594 8.63186 8.51878 8.96585 8.23753 9.23538C7.95628 9.50491 7.58518 9.63968 7.12424 9.63968ZM8.48414 18.8741H5.77711V10.7412H8.48414V18.8741ZM12.6792 11.8911L12.7739 11.7481C13.3368 10.9519 14.1141 10.5537 15.1058 10.5537C16.0433 10.5537 16.7972 10.8623 17.3675 11.4795C17.9378 12.0967 18.223 13.0069 18.223 14.21V18.8741H15.5159V14.5264C15.5159 13.2998 15.0628 12.6866 14.1565 12.6866C13.8128 12.6866 13.5237 12.7823 13.2894 12.9737C13.055 13.1651 12.8792 13.3975 12.762 13.6709C12.7073 13.8116 12.68 14.0303 12.68 14.3272V18.8741H9.97295C9.983 16.7714 9.98874 15.0719 9.99017 13.7757V12.6139C9.98874 11.5864 9.983 10.9622 9.97295 10.7412H12.68L12.6792 11.8911Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Mail.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var Mail = (props) => {
  return /* @__PURE__ */ jsx6(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx6(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.66699 3.33334H18.3337V16.6667H1.66699V3.33334ZM3.33366 5.00001V6.56832L10.0003 9.90165L16.667 6.56831V5.00001H3.33366ZM16.667 8.4317L10.0003 11.765L3.33366 8.43171V15H16.667V8.4317Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Messenger.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var Messenger = (props) => {
  return /* @__PURE__ */ jsx7(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx7(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 9C2 5.68629 4.68629 3 8 3H16C19.3137 3 22 5.68629 22 9V15C22 18.3137 19.3137 21 16 21H3C2.44772 21 2 20.5523 2 20V9ZM8 5C5.79086 5 4 6.79086 4 9V19H16C18.2091 19 20 17.2091 20 15V9C20 6.79086 18.2091 5 16 5H8ZM8 10C8 9.44772 8.44772 9 9 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H9C8.44772 11 8 10.5523 8 10ZM8 14C8 13.4477 8.44772 13 9 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H9C8.44772 15 8 14.5523 8 14Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Threads.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var Threads = (props) => {
  return /* @__PURE__ */ jsx8(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, props), {
      children: /* @__PURE__ */ jsx8(
        "path",
        {
          d: "M16.9062 11.2514C16.8179 11.209 16.7283 11.1683 16.6374 11.1293C16.4793 8.21371 14.8868 6.54454 12.2127 6.52746C12.2006 6.52739 12.1886 6.52739 12.1765 6.52739C10.5771 6.52739 9.24686 7.21036 8.42813 8.45315L9.89876 9.46236C10.5104 8.53404 11.4703 8.33614 12.1772 8.33614C12.1853 8.33614 12.1935 8.33614 12.2016 8.33621C13.0821 8.34183 13.7465 8.59792 14.1765 9.09733C14.4894 9.46092 14.6987 9.96335 14.8023 10.5974C14.0217 10.4647 13.1775 10.4239 12.275 10.4757C9.73265 10.6222 8.09824 12.1055 8.20801 14.1666C8.26371 15.2121 8.78436 16.1115 9.67398 16.6991C10.4261 17.1958 11.3949 17.4387 12.4017 17.3837C13.7313 17.3108 14.7744 16.8033 15.5021 15.8754C16.0547 15.1707 16.4042 14.2575 16.5586 13.1068C17.1922 13.4893 17.6618 13.9928 17.9212 14.5979C18.3622 15.6267 18.3879 17.3172 17.0091 18.6954C15.801 19.9028 14.3488 20.4251 12.1542 20.4412C9.71979 20.4232 7.87867 19.6421 6.68162 18.1198C5.56068 16.6943 4.98138 14.6353 4.95976 12C4.98138 9.36466 5.56068 7.30567 6.68162 5.88018C7.87867 4.35787 9.71976 3.57685 12.1542 3.55875C14.6063 3.57699 16.4795 4.36176 17.7223 5.89143C18.3318 6.64156 18.7912 7.5849 19.0941 8.6848L20.8175 8.22482C20.4504 6.87096 19.8726 5.70433 19.0865 4.73681C17.4931 2.77571 15.1628 1.77084 12.1602 1.75H12.1482C9.15171 1.77076 6.84748 2.77946 5.29949 4.74805C3.922 6.49985 3.21145 8.93735 3.18757 11.9928L3.1875 12L3.18757 12.0072C3.21145 15.0626 3.922 17.5002 5.29949 19.252C6.84748 21.2205 9.15171 22.2293 12.1482 22.25H12.1602C14.8242 22.2315 16.702 21.5338 18.2489 19.9876C20.2729 17.9649 20.2119 15.4294 19.5449 13.8729C19.0663 12.7567 18.1539 11.8501 16.9062 11.2514ZM12.3065 15.5776C11.1923 15.6404 10.0347 15.14 9.97759 14.0684C9.93528 13.2738 10.5428 12.3872 12.3749 12.2815C12.5847 12.2694 12.7906 12.2635 12.9928 12.2635C13.6583 12.2635 14.2809 12.3282 14.8468 12.452C14.6357 15.0894 13.3975 15.5177 12.3065 15.5776Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Whatsapp.tsx
import { jsx as jsx9, jsxs as jsxs3 } from "react/jsx-runtime";
var Whatsapp = (props) => {
  return /* @__PURE__ */ jsxs3(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx9(
          "path",
          {
            d: "M7.60567 6.21294C7.74897 6.21874 7.90771 6.22553 8.05857 6.56063C8.16132 6.78928 8.33407 7.21502 8.47205 7.55507C8.57428 7.80702 8.65742 8.01193 8.67885 8.05475C8.72921 8.15535 8.7626 8.27315 8.6956 8.40725C8.6853 8.42787 8.6758 8.4473 8.66673 8.46585C8.61681 8.56797 8.57993 8.64338 8.49461 8.74279C8.46051 8.78251 8.42527 8.82536 8.39006 8.86817C8.32114 8.95196 8.25234 9.0356 8.19256 9.0953C8.09163 9.19558 7.98653 9.30462 8.10411 9.50594C8.22168 9.70727 8.62554 10.3661 9.22382 10.8996C9.86776 11.4737 10.4269 11.7162 10.71 11.8389C10.765 11.8627 10.8095 11.882 10.8423 11.8984C11.0437 11.999 11.161 11.9822 11.2784 11.8478C11.3959 11.7135 11.7811 11.2604 11.9155 11.059C12.0498 10.8575 12.1839 10.8909 12.3684 10.9581C12.5528 11.0253 13.5422 11.5122 13.7436 11.6129C13.7832 11.6327 13.8202 11.6506 13.8545 11.6671C13.9946 11.7346 14.0891 11.7802 14.1295 11.8478C14.1797 11.932 14.1796 12.3347 14.012 12.8046C13.8444 13.2746 13.0228 13.7279 12.6537 13.7614C12.6181 13.7647 12.5828 13.7688 12.5465 13.7731C12.2054 13.8132 11.7749 13.8637 10.2385 13.2579C8.34617 12.5116 7.09894 10.6616 6.843 10.2819C6.82225 10.2511 6.80802 10.23 6.80048 10.2199L6.7981 10.2167C6.68911 10.071 5.97877 9.1212 5.97877 8.13849C5.97877 7.21211 6.434 6.7263 6.64364 6.50258C6.65808 6.48717 6.67135 6.47301 6.68323 6.46003C6.86759 6.25859 7.08566 6.20823 7.21988 6.20823L7.60567 6.21294Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx9(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.94922 18.125L3.09203 13.9525C2.38601 12.7284 2.01517 11.3399 2.01687 9.92687C2.01874 5.48701 5.63184 1.875 10.0718 1.875C12.2264 1.87609 14.2487 2.71456 15.7696 4.23659C17.2906 5.75862 18.1274 7.78171 18.1266 9.93333C18.1247 14.3729 14.511 17.9855 10.0717 17.9855H10.0682C8.72023 17.985 7.3957 17.6468 6.21917 17.0053L1.94922 18.125ZM10.0742 3.23522C6.3813 3.23522 3.37808 6.23735 3.37677 9.92741C3.37495 11.1875 3.72978 12.4223 4.40025 13.4892L4.55953 13.7424L3.88309 16.2119L6.41699 15.5475L6.66167 15.6925C7.68931 16.3024 8.86759 16.6249 10.0692 16.6255H10.0717C13.7618 16.6255 16.765 13.6231 16.7664 9.93278C16.7692 9.05321 16.5975 8.18183 16.2612 7.36908C15.9249 6.55633 15.4308 5.81836 14.8074 5.19789C14.1874 4.57402 13.4498 4.07932 12.6374 3.74243C11.8249 3.40554 10.9537 3.23314 10.0742 3.23522Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/social/WhatsappCheck.tsx
import { jsx as jsx10, jsxs as jsxs4 } from "react/jsx-runtime";
var WhatsappCheck = (props) => /* @__PURE__ */ jsxs4(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx10(
        "mask",
        {
          id: "mask0_16552_13236",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "12",
          y: "12",
          width: "12",
          height: "12",
          children: /* @__PURE__ */ jsx10("rect", { x: "12.5", y: "12.5", width: "11", height: "11", stroke: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ jsx10("g", { mask: "url(#mask0_16552_13236)" }),
      /* @__PURE__ */ jsx10(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.1384 22.2534C20.4111 22.2534 22.2534 20.4111 22.2534 18.1384C22.2534 15.8658 20.4111 14.0234 18.1384 14.0234C15.8658 14.0234 14.0234 15.8658 14.0234 18.1384C14.0234 20.4111 15.8658 22.2534 18.1384 22.2534ZM17.5518 19.9854L19.9521 17.0518L19.3151 16.5306L17.4907 18.7604L16.6982 17.968L16.1163 18.5499L17.5518 19.9854Z",
          fill: "#22C55E"
        }
      ),
      /* @__PURE__ */ jsx10(
        "path",
        {
          d: "M12.0859 2.25C14.6714 2.25131 17.0987 3.25755 18.9238 5.08398C20.7488 6.91037 21.7529 9.33813 21.752 11.9199C21.7518 12.3695 21.7172 12.8117 21.6572 13.2451C21.1892 12.8846 20.6673 12.5907 20.1045 12.3799C20.1132 12.2274 20.1191 12.0735 20.1191 11.9189C20.1224 10.8636 19.9171 9.81794 19.5137 8.84277C19.1101 7.86747 18.5167 6.98187 17.7686 6.2373C17.0247 5.48883 16.1398 4.89546 15.165 4.49121C14.1901 4.08694 13.1443 3.87934 12.0889 3.88184C7.65737 3.88184 4.05333 7.48501 4.05176 11.9131C4.04961 13.4251 4.47575 14.9073 5.28027 16.1875L5.47168 16.4912L4.65918 19.4541L7.7002 18.6572L7.99414 18.8311C9.22724 19.5628 10.6412 19.9494 12.083 19.9502H12.0859C12.1653 19.9502 12.2444 19.9466 12.3232 19.9443C12.5184 20.5141 12.7972 21.0446 13.1445 21.5225C12.7967 21.5606 12.4437 21.583 12.0859 21.583H12.082C10.4645 21.5823 8.87472 21.1761 7.46289 20.4062L2.33887 21.75L3.70996 16.7432C2.86275 15.2743 2.41788 13.6078 2.41992 11.9121C2.42223 6.58435 6.75804 2.25002 12.0859 2.25ZM9.12695 7.45508C9.29883 7.46204 9.48901 7.47118 9.66992 7.87305C9.79323 8.14746 10.0005 8.65844 10.166 9.06641C10.2887 9.36866 10.3883 9.61464 10.4141 9.66602C10.4745 9.78672 10.5149 9.92799 10.4346 10.0889C10.4222 10.1136 10.4103 10.137 10.3994 10.1592C10.3396 10.2815 10.2956 10.3721 10.1934 10.4912C10.1525 10.5388 10.1105 10.5904 10.0684 10.6416C9.98574 10.742 9.90273 10.8424 9.83105 10.9141C9.70993 11.0344 9.58352 11.1656 9.72461 11.4072C9.8657 11.6488 10.3505 12.439 11.0684 13.0791C11.841 13.768 12.5118 14.0597 12.8516 14.207C12.9175 14.2356 12.9714 14.2587 13.0107 14.2783C13.0973 14.3215 13.171 14.3455 13.2363 14.3525C12.8705 14.8296 12.5737 15.3627 12.3633 15.9375C12.338 15.9277 12.3119 15.9193 12.2861 15.9092C10.0153 15.0137 8.51807 12.7935 8.21094 12.3379C8.18622 12.3012 8.16916 12.2757 8.16016 12.2637L8.15723 12.2598C8.02559 12.0837 7.175 10.9449 7.1748 9.7666C7.1748 8.65493 7.72109 8.07119 7.97266 7.80273C7.98981 7.78443 8.0054 7.7674 8.01953 7.75195C8.24076 7.51023 8.503 7.4502 8.66406 7.4502L9.12695 7.45508ZM14.2822 13.292C14.2875 13.2844 14.2941 13.2776 14.2988 13.2705C14.3818 13.1462 14.4645 13.0968 14.5557 13.0889C14.4626 13.1542 14.3713 13.2216 14.2822 13.292Z",
          fill: "#E4E4E7"
        }
      )
    ]
  })
);

// src/social/WhatsappTile.tsx
import { jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
var WhatsappTile = (props) => /* @__PURE__ */ jsxs5(
  "svg",
  __spreadProps(__spreadValues({
    width: "80",
    height: "77",
    viewBox: "0 0 80 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx11("g", { filter: "url(#filter0_d_16552_6392)", children: /* @__PURE__ */ jsx11(
        "path",
        {
          d: "M46.9905 15.3466C58.4362 15.4439 58.4359 26.7166 58.3927 34.1271C58.3495 41.5376 57.9185 59.972 57.984 66.9202C58.0496 73.8683 48.1506 75.8413 43.3677 75.366L10.1593 72.9492C2.0553 71.4683 0.892359 61.5942 1.32388 56.8423C1.32388 56.8423 1.95294 37.5193 1.68421 27.0966C1.41548 16.6739 8.23692 12.9623 12.9026 12.8129C17.5682 12.6634 46.8627 15.0026 46.9905 15.3466Z",
          fill: "#15803D"
        }
      ) }),
      /* @__PURE__ */ jsx11(
        "path",
        {
          d: "M26.4015 35.4479C26.6899 35.5049 27.0093 35.5687 27.2091 36.2951C27.345 36.7907 27.5605 37.7076 27.7326 38.4399C27.8602 38.9825 27.9639 39.4238 27.9938 39.5173C28.064 39.737 28.0945 39.9861 27.9164 40.2366C27.8891 40.2751 27.8637 40.3115 27.8395 40.3462C27.7061 40.5373 27.6076 40.6784 27.4034 40.8528C27.3218 40.9225 27.2369 40.9982 27.1521 41.0738C26.986 41.2217 26.8203 41.3694 26.6803 41.4715C26.4442 41.6427 26.1969 41.8304 26.3715 42.2753C26.5461 42.7203 27.1562 44.1822 28.1996 45.4516C29.3227 46.8179 30.3788 47.4855 30.9135 47.8235C31.0173 47.8891 31.1014 47.9423 31.1626 47.9858C31.5388 48.2532 31.7816 48.256 32.062 48.021C32.3423 47.786 33.2657 46.9898 33.6013 46.6242C33.937 46.2586 34.1981 46.3686 34.5505 46.563C34.903 46.7574 36.7532 48.0558 37.1294 48.3234C37.2034 48.376 37.2728 48.4239 37.337 48.4682C37.5994 48.6492 37.7765 48.7713 37.8369 48.9211C37.9121 49.1075 37.7848 49.923 37.2969 50.8221C36.8091 51.7211 35.0017 52.38 34.2434 52.3313C34.1704 52.3266 34.0976 52.3239 34.0226 52.321C33.3191 52.2945 32.4312 52.2611 29.5105 50.5488C25.913 48.4399 23.9707 44.2988 23.5721 43.449C23.5398 43.3801 23.5176 43.3328 23.5056 43.31L23.5017 43.3028C23.327 42.9732 22.188 40.8251 22.4982 38.8346C22.7907 36.9581 23.8661 36.1178 24.3614 35.7308C24.3955 35.7042 24.4269 35.6797 24.455 35.6571C24.892 35.3073 25.3496 35.2742 25.6215 35.3165L26.4015 35.4479Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx11(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.1836 57.7906L14.8156 49.6998C13.7719 46.9975 13.4591 44.0679 13.9087 41.2063C15.314 32.2137 23.7728 26.038 32.7662 27.4397C37.13 28.1221 40.9616 30.4588 43.5619 34.0219C46.1621 37.585 47.2185 41.947 46.5377 46.305C45.1322 55.2969 36.6721 61.4737 27.6801 60.0723L27.673 60.0712C24.9428 59.6445 22.3666 58.5414 20.186 56.8706L11.1836 57.7906ZM32.3416 30.1956C24.8615 29.0298 17.8306 34.1627 16.663 41.6367C16.2615 44.1884 16.5905 46.8017 17.6117 49.1743L17.8544 49.7375L15.7047 54.5261L21.0469 53.9802L21.4968 54.3511C23.3858 55.9108 25.6706 56.9361 28.1043 57.3167L28.1094 57.3175C35.5838 58.4824 42.6148 53.3489 43.7827 45.8745C44.066 44.0938 43.9932 42.2745 43.5687 40.5221C43.1441 38.7697 42.3762 37.1189 41.3093 35.6653C40.2504 34.2059 38.9127 32.971 37.3734 32.0322C35.8341 31.0933 34.1238 30.4691 32.3416 30.1956Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx11(
        "path",
        {
          d: "M78.4883 22.6299L72.3066 21.1922",
          stroke: "#B3E100",
          strokeWidth: "1.69",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ jsx11(
        "path",
        {
          d: "M75.9941 8.75293L70.9057 12.546",
          stroke: "#B3E100",
          strokeWidth: "1.69",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ jsx11(
        "path",
        {
          d: "M65.1816 0.922852L64.9818 7.26633",
          stroke: "#B3E100",
          strokeWidth: "1.69",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ jsx11("defs", { children: /* @__PURE__ */ jsxs5(
        "filter",
        {
          id: "filter0_d_16552_6392",
          x: "1.24609",
          y: "9.80615",
          width: "65.1514",
          height: "65.627",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [
            /* @__PURE__ */ jsx11("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ jsx11(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }
            ),
            /* @__PURE__ */ jsx11("feOffset", { dx: "8", dy: "-3" }),
            /* @__PURE__ */ jsx11("feComposite", { in2: "hardAlpha", operator: "out" }),
            /* @__PURE__ */ jsx11(
              "feColorMatrix",
              {
                type: "matrix",
                values: "0 0 0 0 0.0315367 0 0 0 0 0.329327 0 0 0 0 0.14286 0 0 0 1 0"
              }
            ),
            /* @__PURE__ */ jsx11("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_16552_6392" }),
            /* @__PURE__ */ jsx11(
              "feBlend",
              {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_dropShadow_16552_6392",
                result: "shape"
              }
            )
          ]
        }
      ) })
    ]
  })
);

// src/social/X.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var X = (props) => {
  return /* @__PURE__ */ jsx12(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx12(
        "path",
        {
          d: "M4.08849 5.36328L10.2273 13.5712L4.0498 20.2447H5.44022L10.8487 14.4018L15.2185 20.2447H19.9498L13.4655 11.5751L19.2155 5.36328H17.8251L12.8443 10.7443L8.81981 5.36328H4.08849ZM6.13316 6.38734H8.3067L17.9049 19.2206H15.7313L6.13316 6.38734Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  AppleIcon,
  ChatIcon,
  Facebook,
  GoogleIcon,
  LinkedIn,
  Mail,
  Messenger,
  Threads,
  Whatsapp,
  WhatsappCheck,
  WhatsappTile,
  X
};
//# sourceMappingURL=chunk-WNNY474Q.mjs.map